import Button from 'zoomforth_component_lib/btn_basic.jsx';
export default Button;

